export class Storage {
    static TOKEN_KEY = 'TOKEN_KEY'; //value类型为String
    static ACCESS_KEY = 'ACCESS_KEY'; //value类型为String
    static SECRET_KEY = 'SECRET_KEY'; //value类型为String
    static TIMESTAMP_KEY = 'TIMESTAMP_KEY'; //时间戳，value类型为long
    static TENANT_KEY = 'TENANT_KEY';
    static set(key, value, isLocal = true) {
        if (isLocal) {
            localStorage.setItem(key, value);
        } else {
            sessionStorage.setItem(key, value);
        }
    }
    static get(key, isLocal = true) {
        if (isLocal) {
            return localStorage.getItem(key);
        }
        return sessionStorage.getItem(key);
    }
    static remove(key, isLocal = true) {
        if (isLocal) {
            localStorage.removeItem(key);
        } else {
            sessionStorage.removeItem(key);
        }
    }
    static clearAll(isLocal = true) {
        if (isLocal) {
            localStorage.clear();
        } else {
            sessionStorage.clear();
        }
    }
}
